import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import BeatingHeart from '../BeatingHeart';

function BeInclusiveHeart() {
  return (
    <BeatingHeart>
      <StaticImage
        src="../../../assets/images/integrations/beinclusive.png"
        alt="Be Inclusive"
        objectFit="contain"
        placeholder="none"
        width={150}
        height={150}
      />
    </BeatingHeart>
  );
}

export default BeInclusiveHeart;
